import './App.css';

import HeroSection from './components/HeroSection';
import AboutMeSection from './components/AboutMeSection';
import ClarityCallSection from './components/ClarityCallSection';
import WhySection from './components/WhySection';
import BookingForm from './components/BookingForm';
import TestimonialCarousel from './components/TestimonialCarousel';
import Footer from './components/Footer';
import StickyMobileCTA from './components/StickyMobileCTA';

const testimonials = [
  {
    imageSrc: `${process.env.PUBLIC_URL}/assets/sonal.jpeg`,
    name: "Sonal",
    testimonialText: "Dear siri, thank you so much for all that you do with so much love & kindness in your heart, it just reflects in your words & actions.. I am so blessed to connect with you & the wisdom you share so effortlessly like a magical flow creating lifelong transformations. Thankyou for creating this world a better place for our future generations to come. Keep shining & spread the light of love & happiness. Love you.. more power to you"
  },
  {
    imageSrc: `${process.env.PUBLIC_URL}/assets/poorti.jpeg`,
    name: "Poorti",
    testimonialText: "Sireesha is a very calm and composed person and makes you feel comfortable & at ease in her sessions. This has helped me to open about my challenges easily with her. She has helped me create and build habits to focus and work on my goals more productively. Thankyou Vidya for being you & all the help. Looking forward for more sessions"
  },
  {
    imageSrc: `${process.env.PUBLIC_URL}/assets/pratiksha.jpeg`,
    name: "Pratiksha",
    testimonialText: "Sireesha is one of the healer, that I've come across in recent times. I have attended many of her clubhouse lives on various topics regarding how to stick to your habits, improving relationships etc. She truly wants to transform the lives of peopleand has been there for me whenever I need her the most. I recommend all of you reading this, to consider taking your life transforming sessions from her. It'll be totally worth it. I Promise!!!"
  }
];

function App() {
  return (
    <div className="system-container">
      <main>
        <HeroSection />
        <WhySection />
        <AboutMeSection />
        <ClarityCallSection />
        <section className="testimonial-section" aria-label="Client Testimonials">
          <div className="testimonial-section-inner">
            <h2 className="text-center text-brand-800 font-semibold">Testimonials</h2>
            <TestimonialCarousel testimonials={testimonials} />
          </div>
        </section>
        <BookingForm />
        <Footer />
      </main>
      <StickyMobileCTA />
    </div>
  );
}

export default App;
